// extracted by mini-css-extract-plugin
export var heroImage = "_gp-1";
export var modal = "_gp-0";